var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"no-captcha-wrap",attrs:{"title":"请完成安全验证","visible":_vm.captchaVisible,"append-to-body":true,"destroy-on-close":true,"close-on-click-modal":false,"width":"390px","top":"40vh"},on:{"update:visible":function($event){_vm.captchaVisible=$event}}},[_c('div',{attrs:{"id":"captcha"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }